import Card from '@perpay-web/components/base/Card/Card';
import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import LegacyFocusLayout from '@perpay-web/components/composite/LegacyFocusLayout/LegacyFocusLayout';
import lightbulb from '@perpay-web/fintech/assets/images/icons/lightbulb.svg';
import employerRejectedImg from '@perpay-web/fintech/assets/images/illustrations/cardSignupEmployerRejected.svg';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import CustomLink from '@perpay-web/fintech/components/base/CustomLink/CustomLink';
import ResponsiveContent from '@perpay-web/fintech/components/base/ResponsiveContent/ResponsiveContent';
import ResponsiveCopy from '@perpay-web/fintech/components/base/ResponsiveCopy/ResponsiveCopy';
import ResponsiveHeader from '@perpay-web/fintech/components/base/ResponsiveHeader/ResponsiveHeader';
import { paths } from '@perpay-web/fintech/props/appPaths';

import styles from './CardEmploymentRejected.scss';

const CardEmploymentRejected = ({
    onClickBack,
    onClickDashboard,
    dashboardURL = paths.dashboard.path,
}) => (
    <LegacyFocusLayout
        className={styles.container}
        footer={
            <>
                <CardCta
                    className={styles['dashboard-button']}
                    Component={CustomLink}
                    onClick={onClickDashboard}
                    href={dashboardURL}
                >
                    Dashboard
                </CardCta>

                <CustomButton
                    action='link'
                    className={styles['employer-info-button']}
                    size='small'
                    onClick={onClickBack}
                >
                    Enter a new employer
                </CustomButton>
            </>
        }
    >
        <ResponsiveHeader>
            The card application is not available
        </ResponsiveHeader>
        <ResponsiveContent height={213.9} className={styles['img-wrapper']}>
            <img
                src={employerRejectedImg}
                alt='Cards showing employer rejected'
                className={styles.illustration}
            />
        </ResponsiveContent>

        <ResponsiveCopy className={styles.copy}>
            The employer you specified is not supported on Perpay at this time.
        </ResponsiveCopy>
        <Card className={styles['employer-card']}>
            <div className={styles.lightbulb}>
                <img src={lightbulb} alt='lightbulb' />
            </div>
            <div>
                <div className={styles.title}>Have another employer?</div>
                <div className={styles.content}>
                    Tap enter a new employer below to update.
                </div>
            </div>
        </Card>
    </LegacyFocusLayout>
);

export default CardEmploymentRejected;
